import {
  getProductFamilies,
  moveProductFamily,
  removeProductFamily,
  setProductFamilyFilters,
  updateProductFamily,
} from '@state/reducers/productFamilyReducer'
import { GridColumns } from '@mui/x-data-grid-pro'
import { ProductFamilyDto } from '@services/dtos'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import ProductFamilyForm from '../forms/ProductFamilyForm'
import * as Icons from '@mui/icons-material'
import { Box } from '@mui/material'

export default function ProductFamiliesTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setProductFamilyFilters({ includeInactive: false }))
    }
  }, [])
    
  const columns: GridColumns<ProductFamilyDto> = useMemo(
    () => [
      { field: 'code', headerName: 'Code', width: 150 },
      { field: 'name', headerName: 'Nom', width: 250 },
      { field: 'description', headerName: 'Description', width: 300 },
      { field: 'productFamily', headerName: 'Famille parente', width: 200, valueGetter: (params) => params.row.productFamily?.name || '' },
      { field: 'color', headerName: 'Couleur', width: 100, renderCell: ({ value }) => (
        <Box
          sx={{
            width: 20,
            height: 20,
            borderRadius: '0.25rem',
            bgcolor: value,
            border: '1px solid #ccc',
            margin: 'auto',
          }}
        />
      )},
      { field: 'icon', headerName: 'Icône', width: 100, renderCell: ({ value }) => {
          const IconComponent = Icons[value as keyof typeof Icons]
          return IconComponent ? <IconComponent /> : null
        }
      },
    ],
    [],
  )

  return (
    <BaseConfigTable<ProductFamilyDto>
      extraActions={(row) => {
        const hasParent = !!row.productFamily

        return [
          {
            key: 'order_increment',
            label: `Monter${hasParent ? ' dans la famille parente' : ''}`,
            icon: <Icons.ArrowUpward fontSize="small" color="primary" />,
            onClick: (row) =>
              dispatch(moveProductFamily({ id: row.id, direction: 'up' })),
          },
          {
            key: 'order_decrement',
            label: `Descendre${hasParent ? ' dans la famille parente' : ''}`,
            icon: <Icons.ArrowDownward fontSize="small" color="primary" />,
            onClick: (row) =>
              dispatch(moveProductFamily({ id: row.id, direction: 'down' })),
          },
        ]
      }}
      extraWidth={70}
      columns={columns}
      selectRows={(state) => state.productFamily.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setProductFamilyFilters({ includeInactive: true }))
        return dispatch(getProductFamilies())
      }}
      deleteThunk={removeProductFamily}
      toggleThunk={(id, isActive) => updateProductFamily({ id, dto: { isActive } })}
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setProductFamilyFilters({ page }))
        dispatch(getProductFamilies())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <ProductFamilyForm 
          editingProductFamily={editingItem} 
          onClose={onClose}
        />
      )}
      resourceLabel="famille de produits"
      resourcePrefix="la "
    />
  )
}
